// extracted by mini-css-extract-plugin
export default {"group":"GeneralDetails_group__OUEuN","toggleRow":"GeneralDetails_toggleRow__V2vGm","toggleLabel":"GeneralDetails_toggleLabel__3sxn4"};